import { initializeApp } from "firebase/app";
import {addDoc, collection, getFirestore} from 'firebase/firestore'
import {getAuth} from 'firebase/auth';
const firebaseConfig = {
  apiKey: "AIzaSyAsLI0g5gJrI7Rfhr_6A_v6JLj3s_asX40",
  authDomain: "adaptive-chinese-test.firebaseapp.com",
  projectId: "adaptive-chinese-test",
  storageBucket: "adaptive-chinese-test.appspot.com",
  messagingSenderId: "1025077502055",
  appId: "1:1025077502055:web:8d7c41ca976dcc33cfb4c2",
  measurementId: "G-YZG5V4YZSK"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); 
export const db = getFirestore(app)
// it will store the individual score of the user
export const  addScoreRef = collection(db,'users')

